<template>
  <div id="change_pw" class="wrapper">
    <!-- <gb /> -->
    <div id="change_pw_win" ref="change_pw">
      <button id="off_change_pw_win" @click="goTo('/main')">
        <img src="@/assets/images/icon/off.svg" alt="icon" />
      </button>
      <h2>Change password</h2>
      <label> Basic Information </label>
      <form>
        <div class="input">
          <span class="label"> Original password </span>
          <input type="password" v-model="original_pw" />
        </div>
        <div class="input">
          <span class="label"> New Password </span>
          <input type="password" v-model="new_pw" />
        </div>
        <div class="input">
          <span class="label"> Confirm Password </span>
          <input type="password" v-model="new_pw_confirm" />
        </div>
      </form>
      <div class="btn">
        <button type="submit" @click="send()">ENTER</button>
      </div>
    </div>

  </div>
</template>

<script setup>
import { token_expired } from "@/assets/js/token_expired";
import axios from "axios";
import Swal from "sweetalert2";
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
const router = useRouter();
const store = useStore();

const original_pw = ref("");
const new_pw = ref("");
const new_pw_confirm = ref("");

const change_pw = ref(null);
const view = ref(false);

function goTo(data) {
  router.push(`${data}`);
}

function send() {
  // if (original_pw.value !== localStorage.getItem("pw")) {
  //   Swal.fire({
  //     title: "Error",
  //     text: "Please check your original password.",
  //     icon: "error",
  //     confirmButtonText: "Close",
  //   });
  //   return;
  // }

  if (new_pw.value.length < 8) {
    Swal.fire({
      title: "Error",
      text: "The password cannot be less than 8 characters in length.",
      icon: "error",
      confirmButtonText: "Close",
    });
    return;
  }

  if (new_pw.value !== new_pw_confirm.value) {
    Swal.fire({
      title: "Error",
      text: "Please double confirm your new password.",
      icon: "error",
      confirmButtonText: "Close",
    });
    return;
  }

  const FormData = require("form-data");
  let data = new FormData();
  data.append("tch_account", localStorage.getItem("ac"));
  data.append("school_guid", localStorage.getItem("school_guid"));
  data.append("current_password", original_pw.value);
  data.append("new_password", new_pw.value);

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${store.state.path}api/db/password-reset/patch`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    data: data,
  };

  axios
    .request(config)
    .then((response) => {

      if (response.data.code == -2) {
        // 帳號沒有權限
        Swal.fire({
          title: "Error",
          text: "This account is not enabled.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }

      if (response.data.code == -3) {
        // 帳號到期
        Swal.fire({
          title: "Error",
          text: "This account has expired.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }

      if (response.status == 520) {
        send();
      }

      token_expired(response, router);
      console.log(response.data);
      if (
        response.data.msg == "New password must be longer than 8 characters"
      ) {
        Swal.fire({
          title: "Error",
          text: "The password cannot be less than 8 characters in length.",
          icon: "error",
          confirmButtonText: "Close",
        });
        return;
      }
      Swal.fire({
        title: "Information",
        text: "Your password has been changed.",
        icon: "success",
        confirmButtonText: "OK",
        allowOutsideClick: false, // 禁止點擊背景關閉
        allowEscapeKey: false, // 禁止按Esc鍵關閉
        showCloseButton: false, // 不顯示右上角的關閉按鈕
      }).then((result) => {
        if (result.isConfirmed) {
          //前往
          goTo("/main");
        }
      });
    })
    .catch((error) => {
      if (error.status == 520) {
        send();
      }

      token_expired(error, router);
      console.log(error);
    });
}

const adjustZoom = (view) => {
  const baseWidth = 1920;
  const baseHeight = 1080;

  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;

  const scaleWidth = windowWidth / baseWidth;
  const scaleHeight = windowHeight / baseHeight;

  const scale = Math.min(scaleWidth, scaleHeight);

  if (view) {
    view.style.transform = `scale(${scale}) translate(-50%,-50%)`;
  }
};

onMounted(() => {
  adjustZoom(change_pw.value);
  view.value = true;
});
</script>
